import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableSkeleton,
} from "@egaranti/components";

import EmptyTable from "@/components/shared/EmptyTable";
import { useTranslation } from "react-i18next";

const ReportTable = ({
  data,
  loading,
  columns,
  renderRow,
  emptyTitle,
  emptyDescription,
  colSpan,
}) => {
  const { t } = useTranslation();
  const resolvedEmptyTitle =
    emptyTitle || t("common.noData", "Veri bulunamadı");
  const resolvedEmptyDescription =
    emptyDescription ||
    t(
      "common.noDataForSelection",
      "Seçilen kriterlere uygun veri bulunamadı",
    );

  if (loading) {
    return (
      <Table>
        <TableSkeleton colSpan={colSpan || columns.length} />
      </Table>
    );
  }

  if (!data || data.length === 0) {
    return (
      <EmptyTable title={resolvedEmptyTitle} desc={resolvedEmptyDescription} />
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          {columns.map((column, index) => (
            <TableHead key={index}>{column}</TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>{data.map(renderRow)}</TableBody>
    </Table>
  );
};

export default ReportTable;
